import { useContext, useEffect, useMemo } from 'react';

import { AuthContext } from '@mint-lib/auth';
import {
  sendAuthenticate,
  socket,
  SOCKET_PATH,
  URL,
} from '@mint-sdk/api-recommendations/socket';
import { Manager } from 'socket.io-client';

import { useWSListeners } from './useWSListeners.js';

const useNotificationWS = () => {
  const auth = useContext(AuthContext);
  const authorization = encodeURIComponent(auth.getAccessToken() ?? '');

  const rawSocket = useMemo(() => {
    const manager = new Manager(URL.concat(SOCKET_PATH), {
      transports: ['websocket'],
      path: SOCKET_PATH,
      autoConnect: false,
    });

    return manager.socket('/');
  }, []);

  useEffect(() => {
    socket.provideClient(rawSocket);
  }, [rawSocket]);

  useWSListeners(); // FYI: Call ONLY after providing client

  useEffect(() => {
    if (!rawSocket.connected) {
      rawSocket.connect();
    }

    return () => {
      if (rawSocket.connected) {
        rawSocket.disconnect();
      }
    };
  }, [rawSocket]);

  useEffect(() => {
    const authenticate = () => sendAuthenticate({ authorization });

    rawSocket.on('connect', authenticate);
    if (rawSocket.connected) authenticate();

    return () => {
      rawSocket.off('connect', authenticate);
    };
  }, [rawSocket, authorization]);

  return {
    isConnected: rawSocket.connected,
  };
};

export { useNotificationWS };
